/* Abbuchungswunsch (Pia-Finanzen F1, 02.11.2026, Betreiber: „Cagla soll Abbuchungswünsche von Kunden anlegen können, mehr nicht“):
   Ein Kunde möchte etwas mit dem Beitrag abbuchen lassen (z. B. Handschuhe). Das Team legt hier nur einen Entwurf an — Philip gibt ihn
   in der Freigabe-Zentrale frei, erst dann kommt der Betrag auf die nächste Monatsrechnung. Unten stehen die Wünsche dieses Mitglieds
   mit ihrem Stand (wartet auf Freigabe, im Rechnungslauf, abgerechnet, verworfen). Backend: backend/pia_finanzen/router.py. */
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2, ShoppingBag } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { piaFinanzenAPI } from '@/lib/api';

const euro = (w) => `${Number(w || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export default function Abbuchungswunsch({ leadId, membershipId }) {
  const [lage, setLage] = useState(null);
  const [form, setForm] = useState(null);             // { text, betrag, notiz }
  const [busy, setBusy] = useState(false);

  const lade = useCallback(() => {
    piaFinanzenAPI.abbuchungswunschLage(leadId).then((r) => setLage(r.data)).catch(() => setLage(null));
  }, [leadId]);
  useEffect(() => { lade(); }, [lade]);

  const speichern = async () => {
    const betrag = Number(String(form.betrag).replace(',', '.'));
    if (form.text.trim().length < 3 || !(betrag > 0)) { toast.error('Was und wie viel?'); return; }
    setBusy(true);
    try {
      const r = await piaFinanzenAPI.abbuchungswunsch({ lead_id: leadId, membership_id: membershipId || null, text: form.text.trim(), betrag,
                                                        notiz: form.notiz.trim() || null });
      toast.success(r.data.meldung || 'Liegt zur Freigabe');
      setForm(null); lade();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Speichern fehlgeschlagen'); }
    setBusy(false);
  };

  const wuensche = lage?.wuensche || [];
  return (
    <div className="space-y-2" data-testid="abbuchungswunsch">
      {form ? (
        <div className="rounded-md border border-border/60 p-2 space-y-2 text-xs">
          <p className="font-medium">Abbuchungswunsch des Kunden — kommt nach Philips Freigabe auf die nächste Monatsrechnung</p>
          <div className="flex flex-wrap gap-2">
            <input autoFocus value={form.text} onChange={(e) => setForm((f) => ({ ...f, text: e.target.value }))} maxLength={80} placeholder="Was? z. B. Boxhandschuhe"
                   className="h-8 flex-1 min-w-[10rem] rounded-md border border-input bg-background px-2" data-testid="abbuchungswunsch-text" />
            <input value={form.betrag} onChange={(e) => setForm((f) => ({ ...f, betrag: e.target.value }))} inputMode="decimal" placeholder="€"
                   className="h-8 w-20 rounded-md border border-input bg-background px-2" data-testid="abbuchungswunsch-betrag" />
          </div>
          <input value={form.notiz} onChange={(e) => setForm((f) => ({ ...f, notiz: e.target.value }))} maxLength={300} placeholder="Notiz für Philip (optional)"
                 className="h-8 w-full rounded-md border border-input bg-background px-2" />
          <div className="flex gap-2">
            <Button size="sm" disabled={busy} onClick={speichern} data-testid="abbuchungswunsch-speichern">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Zur Freigabe an Philip'}</Button>
            <Button size="sm" variant="outline" disabled={busy} onClick={() => setForm(null)}>Abbrechen</Button>
          </div>
        </div>
      ) : (
        <Button size="sm" variant="outline" className="gap-1.5" onClick={() => setForm({ text: '', betrag: '', notiz: '' })} data-testid="abbuchungswunsch-oeffnen"
                title="Der Kunde möchte etwas mit dem Beitrag abbuchen lassen — Philip gibt es frei">
          <ShoppingBag className="w-4 h-4" /> Abbuchungswunsch
        </Button>
      )}
      {wuensche.length > 0 && (
        <ul className="text-xs space-y-0.5">
          {wuensche.slice(0, 5).map((w) => (
            <li key={w.id} className="flex justify-between gap-2">
              <span>{w.text} · {euro(w.betrag)}</span>
              <span className="text-muted-foreground">{w.stand_text}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
